/**
 * 存储管理工具函数
 */

const STORAGE_KEY = 'costSplitRecords';

/**
 * 保存记录到本地存储
 * @param {Object} form - 表单数据
 * @param {Array} result - 计算结果
 * @returns {Object} 保存的记录
 */
export function saveRecord(form, result) {
  // 创建新记录
  const newRecord = {
    id: Date.now(),
    time: new Date().toLocaleString(),
    form: JSON.parse(JSON.stringify(form)),
    result: JSON.parse(JSON.stringify(result))
  };

  // 读取现有记录
  const records = getHistoryRecords();

  // 将新记录插入数组头部
  records.unshift(newRecord);

  // 保存回本地存储
  localStorage.setItem(STORAGE_KEY, JSON.stringify(records));

  return newRecord;
}

/**
 * 读取历史记录
 * @returns {Array} 历史记录列表
 */
export function getHistoryRecords() {
  return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
}

/**
 * 删除历史记录
 * @param {number} id - 记录ID
 */
export function deleteHistoryRecord(id) {
  const records = getHistoryRecords();
  const updatedRecords = records.filter(record => record.id !== id);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedRecords));
  return updatedRecords;
}
